import React from 'react';
import "./ContrapartidaUtilizada.css";
import Navbar from '../../../components/layout/Navbar/Navbar';
// import Sidebar from '../../../components/Dashboard-ES/SideBar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import { ESTABELECIMENTO_SAUDE_SIDEBAR } from '../../../constants/sidebarConfig';


const ContrapartidaUtilizada = () => {
  return (
    <div className="ContrapartidaUtilizada-Page">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={ESTABELECIMENTO_SAUDE_SIDEBAR}/>
        </div>
        <div className="main-content">
        </div>
      </div>
    </div>
  );
};

export default ContrapartidaUtilizada;
